export const GET_TWILIO_ACCESS_TOKEN_REQUEST = 'GET_TWILIO_ACCESS_TOKEN_REQUEST';
export const GET_TWILIO_ACCESS_TOKEN_SUCCESS = 'GET_TWILIO_ACCESS_TOKEN_SUCCESS';
export const GET_TWILIO_ACCESS_TOKEN_FAILURE = 'GET_TWILIO_ACCESS_TOKEN_FAILURE';

export const CLEAR_TWILIO_CONTEXT = 'CLEAR_TWILIO_CONTEXT';
